(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.footer-menu-title:not(.footer-menu-title--social)');

    function closeList(list) {
      list.style.height = list.scrollHeight + 'px';
      list.style.overflow = 'hidden';
      list.style.transition = 'height 0.3s ease';

      requestAnimationFrame(() => {
        list.style.height = '0px';
      });

      list.addEventListener(
        'transitionend',
        () => {
          if (list.style.height === '0px') {
            list.style.display = 'none';
          }
        },
        { once: true }
      );
    }

    function openList(list) {
      list.style.display = 'block';
      list.style.overflow = 'hidden';
      const height = list.scrollHeight + 'px';
      list.style.height = '0px';
      list.style.transition = 'height 0.3s ease';

      requestAnimationFrame(() => {
        list.style.height = height;
      });

      list.addEventListener(
        'transitionend',
        () => {
          if (list.style.height !== '0px') {
            list.style.height = 'auto';
          }
        },
        { once: true }
      );
    }

    headers.forEach((header) => {
      header.addEventListener('click', function () {
        if (window.innerWidth >= 768) return;

        const currentBlock = this.closest('[data-footer-block]');
        const currentList = currentBlock.querySelector('.main-footer__linkslist');

        const isOpen = currentBlock.classList.contains('is-active');

        document.querySelectorAll('[data-footer-block].is-active').forEach((block) => {
          block.classList.remove('is-active');
          const list = block.querySelector('.main-footer__linkslist');
          if (list) closeList(list);
        });

        if (!isOpen) {
          currentBlock.classList.add('is-active');
          if (currentList) openList(currentList);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeisan-im8-hero"] && !Shopify.designMode) return;
  try {
    
  const initSkeisanIm8 = () => {
    document.querySelectorAll('[data-skeisan-im8]').forEach((section) => {
      if (section.dataset.skeisanIm8Ready === 'true') return;

      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-dot]'));
      const prev = section.querySelector('[data-prev]');
      const next = section.querySelector('[data-next]');
      let index = slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (slides.length < 2) return;
      if (index < 0) index = 0;
      section.dataset.skeisanIm8Ready = 'true';

      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      prev?.addEventListener('click', () => show(index - 1));
      next?.addEventListener('click', () => show(index + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => show(Number(dot.dataset.dot)));
      });

      window.setInterval(() => show(index + 1), 5200);
    });
  };

  initSkeisanIm8();
  document.addEventListener('shopify:section:load', initSkeisanIm8);

  } catch(e) { console.error(e); }
})();
})();
